import React from 'react';
import dayjs from 'dayjs';
import { DatePicker } from "antd";
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

function KoMonthFormatter(props) {
  const { onChange, value } = props;
  
  return (
    <DatePicker
      format={"MMM-YYYY"}
      onChange={onChange}
      value={value}
      picker={"month"}
    />
  );
}

export default KoMonthFormatter;
